import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getPublishedJobs, getJobBySlug } from "@/api/jobs";

export const usePublishedJobs = (params = {}) => {
  return useQuery({
    queryKey: ["jobs", "published", params],
    queryFn: () => getPublishedJobs(params),
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export const useInfinitePublishedJobs = (limit = 2) => {
  return useInfiniteQuery({
    queryKey: ["jobs", "published", "infinite", limit],
    queryFn: ({ pageParam }) => getPublishedJobs({ page: pageParam, limit }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.hasMore) {
        return undefined;
      }

      return Number(lastPage?.page || 1) + 1;
    },
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export const useJobBySlug = (slug) => {
  return useQuery({
    queryKey: ["jobs", "published", slug],
    queryFn: () => getJobBySlug(slug),
    enabled: !!slug, // Only fetch when slug is provided
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
